import style from "./style.module.scss";

export function NorwegianLoanPPiInfo(): JSX.Element {
    return <>
            <strong className={style.space}>
            Som kunde i Morrow Bank får du tegne en betalingsforsikring som er kostnadsfri i opptil to måneder.
            </strong>
            <p className={style.space}>
            Forsikringen vil, fra den kostnadsfrie perioden utløper, koste 0,25% av saldo ved hver månedsslutt. 
            Vi vil varsle deg på e-post før den kostnadsfrie perioden utløper og du står fritt til å si den opp uten ekstra kostnad i perioden.
            </p>
            <strong>
            For å være dekket av Betalingsforsikringen må du oppfylle alle kriteriene under:
            </strong>
            <ul className={style.bulletList}>
                <li>
                er fylt 18 år men ikke fylt 66 år, og er bosatt i Norge og registrert i Folkeregisteret, 
                og er medlem av norsk folketrygd eller tilsvarende svensk eller dansk instans,
                </li>
                <li>
                er ikke kjent med forestående arbeidsledighet/permittering,
                </li>
                <li>
                kan utføre ditt vanlige arbeid uten innskrenkninger og ikke har vært sykemeldt i mer enn 30 dager 
                sammenhengende i løpet av de siste 360 dagene,
                </li>
                <li>
                ikke er kjent med eksisterende sykdom/skade. Er heller ikke kjent med sykdom, 
                symptomer eller tegn som direkte eller indirekte kan føre til kritisk sykdom eller dødsfall, og
                </li>
                <li>
                er ansatt eller selvstendig næringsdrivende, og jobber minst 16 timer i uken, 
                i minst seks sammenhengende måneder hos arbeidsgiver/i næringsvirksomhet umiddelbart forut for inntreden i forsikringsavtalen. 
                Med ansatt menes fast ansatt eller midlertidig ansatt med en avtalt kontraktsperiode på minst 12 måneder. 
                Med selvstendig næringsdrivende menes en som for egen regning og 
                risiko driver en vedvarende virksomhet som er egnet til å gi nettoinntekt
                </li>
            </ul>
            <p>
            For viktig informasjon om forsikringen og begrensninger, 
            les <a target="_new" className={style.link} 
                href="https://morrowbank.no/forsikring/betalingsforsikring"> IPID, forkjøpsinformasjonen og vilkår</a>
            </p>
        </>
}
